export default {
    name: "Custom  Clearance",
    meta: {
        icon: "accessibility",
        expanded: true,
        auth: true
    },
    departmentName: "Custom Clearance",
    finalPagePermision: "",
    children: [
        // {
        //   name: "CC-Import Entry",
        //   path: "/CCImport/CCImportEntry",
        //   meta: {
        //     auth: true
        //   },
        //   component: require("../component/CCImport/CCImportEntry.vue")
        // },



        {
            name: "CC-Export Details",
            path: "/CCImport/CCExportDetail",
            permissionName: 'CC Export',
            keywords: ['CC-Export Details', 'Custom  Clearance', 'CC Export'],
            meta: {
                icon: "accessibility",
                auth: true
            },
            component: require("../component/CCImport/viewCCExportDetail.vue"),
            finalPagePermision: "CC Export",

        },
        {
            name: "CC-Import Details",
            path: "/CCImport/CCImportDetails",
            permissionName: 'CC Import',
            keywords: ['CC-Import Details', 'Custom  Clearance', 'CC Import'],
            meta: {
                icon: "accessibility",
                auth: true
            },
            component: require("../component/CCImport/viewCCImportDetails.vue"),
            finalPagePermision: "CC Import",

        },


        {
            name: "CC Export Reports",
            path: "/reports/ccExportReports",
            permissionName: 'CC Export',
            keywords: ['CC Export Reports', 'Custom  Clearance', 'CC Export'],
            meta: {
                icon: "accessibility",
                auth: true
            },
            component: require("../component/reports/ccExportReports.vue"),
            finalPagePermision: "CC Export",

        },
        // {
        //   name: "CC-Import Details",
        //   path: "/CCImport/CCImportDetails",
        //   meta: {
        //     auth: true
        //   },
        //   component: require("../component/CCImport/viewCCImportDetails.vue"),
        //   finalPagePermision: "CC Import",

        // },
        // {
        //   name: "CC Export Reports",
        //   path: "/reports/ccExportReports",
        //   meta: {
        //     auth: true
        //   },
        //   component: require("../component/reports/ccExportReports.vue"),
        //   finalPagePermision: "CC Export",

        // },
        {
            name: "CC Import Reports",
            path: "/reports/ccImportReports",
            permissionName: 'CC Import',
            keywords: ['CC Import Reports', 'Custom  Clearance', 'CC Import'],
            meta: {
                icon: "accessibility",
                auth: true
            },
            component: require("../component/reports/ccImportReports.vue"),
            finalPagePermision: "CC Import",

        },
    ]
};


// WEBPACK FOOTER //
// ./src/sidebar/CCImport.js